import React, { useEffect, useMemo, useState } from "react";
import TornaAlMenu from "../components/TornaAlMenu";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function MediaAppPage() {
  const [prodotti, setProdotti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [uploadingId, setUploadingId] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    setLoading(true);
    setMsg("");
    try {
      const res = await authFetch("/api/prodotti/?scope=catalogo&tipo_listino=cliente");
      const data = await res.json();
      setProdotti(Array.isArray(data) ? data : data.results || []);
    } catch (e) {
      setMsg("Errore caricamento prodotti.");
      setProdotti([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return prodotti.filter((p) =>
      !term ||
      String(p.name || "").toLowerCase().includes(term) ||
      String(p.category || "").toLowerCase().includes(term)
    );
  }, [prodotti, q]);

  const uploadImage = async (productId, file) => {
    if (!file) return;

    const body = new FormData();
    body.append("image", file);

    setUploadingId(productId);
    setMsg("");

    try {
      const res = await authFetch(`${API_URL}/api/prodotti/${productId}/image/`, {
        method: "POST",
        body,
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.detail || "Errore upload immagine.");
      }

      setProdotti((rows) => rows.map((p) => (p.id === productId ? data : p)));
      setMsg("✅ Immagine aggiornata. Sarà visibile sia nel gestionale sia nell'app cliente.");
    } catch (e) {
      setMsg(`❌ ${e.message || "Errore upload immagine."}`);
    } finally {
      setUploadingId(null);
    }
  };

  return (
    <div className="container py-4">
      <TornaAlMenu to="/gestione-app-clienti" />

      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">Media condivisi</div>
          <h1 className="fw-bold mb-1">Media Prodotti & App</h1>
          <div className="text-muted">
            Carica immagini prodotto condivise tra gestionale, catalogo app e area cliente.
          </div>
        </div>

        <input
          className="form-control"
          placeholder="Cerca prodotto o categoria…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ maxWidth: 320 }}
        />
      </div>

      {msg && <div className="alert alert-info rounded-4">{msg}</div>}

      {loading ? (
        <p>Caricamento…</p>
      ) : filtered.length === 0 ? (
        <div className="alert alert-warning rounded-4">Nessun prodotto trovato.</div>
      ) : (
        <div className="row g-3">
          {filtered.map((p) => (
            <div className="col-12 col-md-6 col-xl-4" key={p.id}>
              <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                <div
                  style={{
                    height: 190,
                    background: "#f3f3f3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {p.image_url ? (
                    <img
                      src={p.image_url}
                      alt={p.name}
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  ) : (
                    <div className="text-center text-muted">
                      <div style={{ fontSize: 46 }}>🖼️</div>
                      <div className="small">Nessuna immagine</div>
                    </div>
                  )}
                </div>

                <div className="card-body p-4">
                  <div className="badge rounded-pill text-bg-dark mb-2">
                    {p.category || "PRODOTTO"}
                  </div>
                  <h5 className="fw-bold mb-3">{p.name}</h5>

                  <label className="btn btn-outline-success w-100 rounded-pill">
                    {uploadingId === p.id ? "Caricamento…" : "Carica / cambia immagine"}
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      disabled={uploadingId === p.id}
                      onChange={(e) => uploadImage(p.id, e.target.files?.[0])}
                    />
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
